export default __webpack_public_path__ + "static/media/convert.146605f6.svg";